// Brand constants for Digi Savvy
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_smart-landing-ai-1/artifacts/upa94qri_DS%20LOGOs.png";

// Friendly female AI avatar (free Unsplash, smiling headshot)
export const AVATAR_IMAGE_URL = "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop&crop=faces&q=80&auto=format";

export const WHATSAPP_NUMBER = "919818825449"; // +91 98188 25449
export const WHATSAPP_DISPLAY = "+91 98188 25449";

export const waLink = (text) => {
  const msg = encodeURIComponent(text || "Hi Digi Savvy, I'd like to know more about your real-estate marketing services.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
};

export const SOCIALS = [
  { name: "Instagram", href: "https://instagram.com/digisavvyy?igshid=MzRlODBiNWFlZA==", icon: "instagram" },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/digi-savvy/", icon: "linkedin" },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61552677833279", icon: "facebook" },
  { name: "YouTube", href: "https://www.youtube.com/@DIGISAVVYy/about", icon: "youtube" },
  { name: "WhatsApp", href: `https://wa.me/${WHATSAPP_NUMBER}`, icon: "whatsapp" },
  { name: "Website", href: "https://digisavvyy.com/", icon: "globe" },
];

export const CITIES = [
  "Delhi", "Faridabad", "Noida", "Gurugram", "Sonipat", "Naugaon",
  "Himachal", "Uttarakhand", "Lucknow", "Khatu Shyam", "Jaipur",
  "Dholera", "Dubai",
];
